import { TableService } from './../table.service';

import {
  Component,
  ViewEncapsulation,
  Input,
  ElementRef,
  ViewChild,
  OnInit,
  AfterViewInit,
  EventEmitter,
  Output,
  Renderer2
} from '@angular/core';

import 'rxjs/add/operator/distinctUntilChanged';

@Component({
  selector     : 'bui-table',
  encapsulation: ViewEncapsulation.None,
  template:`<div class="ant-table-wrapper" [class.ant-table-empty]="data.length==0">
  <nz-spin [nzSpinning]="showLoading">
    <div>
      <div class="ant-table" [class.ant-table-bordered]="showBordered" [class.ant-table-large]="(nzSize!=='middle')&&(nzSize!=='small')"
        [class.ant-table-middle]="nzSize=='middle'" [class.ant-table-small]="nzSize=='small'">
        <div class="ant-table-title" *ngIf="showTitle">
          <ng-content select="[bui-table-title]"></ng-content>
        </div>
        <div class="ant-table-content" [class.fix-mode]="fixMode" [class.cross-mode]="crossMode" [style.maxHeight]="fixMode?maxHeight:'100%'"
          [style.overflow]="fixMode?'auto':'hidden'" (scroll)="onScroll($event)">
          <div class="ant-table-body">
            <table>
              <ng-content></ng-content>
            </table>
          </div>
          <div class="ant-table-placeholder" *ngIf="data.length==0 && !customNoResult">
            <span>没有数据</span>
          </div>
          <div class="ant-table-placeholder" *ngIf="data.length==0 && customNoResult">
            <ng-content select="[noResult]"></ng-content>
          </div>
        </div>
        <div class="ant-table-footer" *ngIf="showFooter">
          <ng-content select="[bui-table-footer]"></ng-content>
        </div>
      </div>
    </div>
  </nz-spin>
  <bui-pagination *ngIf="showPagination&&data.length" class="ant-table-pagination" [showSizeChanger]="showSizeChanger" [showQuickJumper]="showQuickJumper"
    [showTotal]="showTotal" [nzSize]="(nzSize=='middle'||nzSize=='small')?'small':''" [(pageSize)]="pageSize" [total]="total"
    [(currentPage)]="currentPage" (onCurrentPageChange)="pageChangeClick($event)">
  </bui-pagination>
</div>
`,
  styles: [
    `.ant-table-wrapper {
  zoom: 1;
}
.ant-table-wrapper:before,
.ant-table-wrapper:after {
  content: " ";
  display: table;
}
.ant-table-wrapper:after {
  clear: both;
  visibility: hidden;
  font-size: 0;
  height: 0;
}
.ant-table {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
  overflow: hidden;
  position: relative;
  border-radius: 4px 4px 0 0;
  /* fix firefox scrollbar bug */
}
.ant-table-body {
  transition: opacity 0.3s ease;
}
.ant-table table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  text-align: left;
  border-radius: 4px 4px 0 0;
  overflow: hidden;
}
.ant-table-thead > tr > th {
  position: relative;
  background: #f7f7f7;
  font-weight: 500;
  transition: background .3s ease;
  text-align: left;
  color: rgba(0, 0, 0, 0.85);
}
.ant-table-thead > tr > th[colspan] {
  text-align: center;
}
.ant-table-thead > tr > th .anticon-filter,
.ant-table-thead > tr > th .ant-table-filter-icon {
  position: relative;
  margin-left: 4px;
  font-size: 12px;
  cursor: pointer;
  color: #aaa;
  transition: all .3s;
  width: 14px;
}
.ant-table-thead > tr > th .anticon-filter:hover,
.ant-table-thead > tr > th .ant-table-filter-icon:hover {
  color: rgba(0, 0, 0, 0.65);
}
.ant-table-thead > tr > th .anticon-filter:after,
.ant-table-thead > tr > th .ant-table-filter-icon:after {
  content: '';
  position: absolute;
  width: 14px;
  height: 50px;
  left: 0;
  top: -19px;
}
.ant-table-thead > tr > th .ant-table-filter-selected.anticon-filter {
  color: #108ee9;
}
.ant-table-thead > tr > th .drag-handle {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 3px;
  border-left: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
  transition: all .3s;
}
.ant-table-thead > tr > th .drag-handle:hover {
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
  cursor: ew-resize;
}
.ant-table-thead > tr > th:hover .drag-handle {
  visibility: visible;
  opacity: 1;
}
.ant-table-tbody > tr > td {
  border-bottom: 1px solid #e9e9e9;
  transition: all .3s;
}
.ant-table-thead > tr,
.ant-table-tbody > tr {
  transition: all .3s;
}
.ant-table-thead > tr.ant-table-row-hover > td,
.ant-table-tbody > tr.ant-table-row-hover > td,
.ant-table-thead > tr:hover > td,
.ant-table-tbody > tr:hover > td {
  background: #ecf6fd;
}
.ant-table-thead > tr:hover {
  background: none;
}
.ant-table-footer {
  padding: 16px 8px;
  background: #f7f7f7;
  border-radius: 0 0 4px 4px;
  position: relative;
}
.ant-table-footer:before {
  content: '';
  height: 1px;
  background: #f7f7f7;
  position: absolute;
  top: -1px;
  width: 100%;
  left: 0;
}
.ant-table.ant-table-bordered .ant-table-footer {
  border: 1px solid #e9e9e9;
}
.ant-table-title {
  padding: 16px 0;
  position: relative;
  top: 1px;
  border-radius: 4px 4px 0 0;
}
.ant-table.ant-table-bordered .ant-table-title {
  border: 1px solid #e9e9e9;
  padding-left: 8px;
  padding-right: 8px;
}
.ant-table-title + .ant-table-content {
  position: relative;
  border-radius: 4px 4px 0 0;
  overflow: hidden;
}
.ant-table-bordered .ant-table-title + .ant-table-content,
.ant-table-bordered .ant-table-title + .ant-table-content table {
  border-radius: 0;
}
.ant-table-without-column-header .ant-table-title + .ant-table-content,
.ant-table-without-column-header table {
  border-radius: 0;
}
.ant-table-tbody > tr.ant-table-row-selected {
  background: #fafafa;
}
.ant-table-thead > tr > th.ant-table-column-sort {
  background: #eee;
}
.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  padding: 16px 8px;
  word-break: break-all;
}
.ant-table-thead > tr > th.ant-table-selection-column-custom {
  padding-left: 16px;
  padding-right: 0;
}
.ant-table-thead > tr > th.ant-table-selection-column,
.ant-table-tbody > tr > td.ant-table-selection-column {
  text-align: center;
  min-width: 62px;
  width: 62px;
}
.ant-table-expand-icon-th,
.ant-table-row-expand-icon-cell {
  text-align: center;
  min-width: 50px;
  width: 50px;
}
.ant-table-header {
  background: #f7f7f7;
  overflow: hidden;
}
.ant-table-header table {
  border-radius: 4px 4px 0 0;
}
.ant-table-loading {
  position: relative;
}
.ant-table-loading .ant-table-body {
  background: #fff;
  opacity: 0.5;
}
.ant-table-loading .ant-table-spin-holder {
  height: 20px;
  line-height: 20px;
  left: 50%;
  top: 50%;
  margin-left: -30px;
  position: absolute;
}
.ant-table-loading .ant-table-with-pagination {
  margin-top: -20px;
}
.ant-table-loading .ant-table-without-pagination {
  margin-top: 10px;
}
.ant-table-middle .ant-table-thead > tr > th:not(.ant-table-selection-column),
.ant-table-middle .ant-table-tbody > tr > td {
  padding: 10px 8px;
}
.ant-table-middle .ant-table-title,
.ant-table-middle .ant-table-footer {
  padding: 10px 8px;
}
.ant-table-middle .ant-table-column-sorter-up:after {
  top: -13px;
  height: 13px;
}
.ant-table-middle .ant-table-column-sorter-down:after {
  bottom: -11px;
  height: 13px;
}
.ant-table-middle .ant-table-thead > tr > th .anticon-filter:after,
.ant-table-middle .ant-table-thead > tr > th .ant-table-filter-icon:after {
  height: 38px;
  top: -13px;
}
.ant-table-small {
  border: 1px solid #e9e9e9;
  border-radius: 4px;
}
.ant-table-small .ant-table-header > table,
.ant-table-small .ant-table-body > table {
  border: 0;
  padding: 0 8px;
}
.ant-table-small .ant-table-thead > tr > th {
  background: #fff;
  border-bottom: 1px solid #e9e9e9;
}
.ant-table-small .ant-table-tbody > tr > td {
  padding: 6px 8px;
}
.ant-table-small .ant-table-title,
.ant-table-small .ant-table-footer,
.ant-table-small .ant-table-thead > tr > th:not(.ant-table-selection-column) {
  padding: 10px 8px;
}
.ant-table-small .ant-table-title {
  border-bottom: 1px solid #e9e9e9;
  top: 0;
}
.ant-table-small .ant-table-header {
  background: #fff;
}
.ant-table-small .ant-table-header table {
  border-bottom: 1px solid #e9e9e9;
}
.ant-table-small .ant-table-placeholder,
.ant-table-small .ant-table-row:last-child td {
  border-bottom: 0;
}
.ant-table-small .ant-table-column-sorter-up:after {
  top: -14px;
  height: 13px;
}
.ant-table-small .ant-table-column-sorter-down:after {
  bottom: -11px;
  height: 13px;
}
.ant-table-small .ant-table-thead > tr > th .anticon-filter:after,
.ant-table-small .ant-table-thead > tr > th .ant-table-filter-icon:after {
  height: 39px;
  top: -14px;
}
.ant-table-column-sorter {
  position: relative;
  margin-left: 4px;
  display: inline-block;
  width: 14px;
  height: 14px;
  vertical-align: middle;
  text-align: center;
}
.ant-table-column-sorter-up,
.ant-table-column-sorter-down {
  line-height: 4px;
  display: block;
  width: 14px;
  cursor: pointer;
}
.ant-table-column-sorter-up:hover .anticon,
.ant-table-column-sorter-down:hover .anticon {
  color: rgba(0, 0, 0, 0.65);
}
.ant-table-column-sorter-up.on .anticon-caret-up,
.ant-table-column-sorter-down.on .anticon-caret-up,
.ant-table-column-sorter-up.on .anticon-caret-down,
.ant-table-column-sorter-down.on .anticon-caret-down {
  color: #108ee9;
}
.ant-table-column-sorter-up:after,
.ant-table-column-sorter-down:after {
  position: absolute;
  content: '';
  height: 20px;
  width: 14px;
  left: 0;
}
.ant-table-column-sorter-up:after {
  top: -19px;
}
.ant-table-column-sorter-down:after {
  bottom: -17px;
}
.ant-table-column-sorter .anticon-caret-up,
.ant-table-column-sorter .anticon-caret-down {
  display: inline-block;
  font-size: 12px;
  font-size: 8px \9;
  transform: scale(0.66666667) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
  line-height: 6px;
  height: 6px;
  color: #aaa;
}
:root .ant-table-column-sorter .anticon-caret-up,
:root .ant-table-column-sorter .anticon-caret-down {
  filter: none;
}
:root .ant-table-column-sorter .anticon-caret-up,
:root .ant-table-column-sorter .anticon-caret-down {
  font-size: 12px;
}
.ant-table-column-sorter .anticon-caret-up:before,
.ant-table-column-sorter .anticon-caret-down:before {
  -moz-transform-origin: 53% 50%;
  /* fix firefox position */
}
.ant-table-bordered .ant-table-header > table,
.ant-table-bordered .ant-table-body > table,
.ant-table-bordered .ant-table-fixed-left table,
.ant-table-bordered .ant-table-fixed-right table {
  border: 1px solid #e9e9e9;
  border-right: 0;
  border-bottom: 0;
}
.ant-table-bordered.ant-table-empty .ant-table-placeholder {
  border-left: 1px solid #e9e9e9;
  border-right: 1px solid #e9e9e9;
}
.ant-table-bordered.ant-table-fixed-header .ant-table-header > table {
  border-bottom: 0;
}
.ant-table-bordered.ant-table-fixed-header .ant-table-body > table {
  border-top: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.ant-table-bordered.ant-table-fixed-header .ant-table-body-inner > table {
  border-top: 0;
}
.ant-table-bordered.ant-table-fixed-header .ant-table-placeholder {
  border: 0;
}
.ant-table-bordered .ant-table-thead > tr > th {
  border-bottom: 1px solid #e9e9e9;
}
.ant-table-bordered .ant-table-thead > tr > th,
.ant-table-bordered .ant-table-tbody > tr > td {
  border-right: 1px solid #e9e9e9;
}
.ant-table-bordered.ant-table-small {
  border-right: 0;
}
.ant-table-bordered.ant-table-small .ant-table-header > table,
.ant-table-bordered.ant-table-small .ant-table-body > table,
.ant-table-bordered.ant-table-small .ant-table-fixed-left table,
.ant-table-bordered.ant-table-small .ant-table-fixed-right table {
  border: 0;
  padding: 0;
}
.ant-table-bordered.ant-table-small .ant-table-title {
  border: 0;
  border-bottom: 1px solid #e9e9e9;
  border-right: 1px solid #e9e9e9;
}
.ant-table-bordered.ant-table-small .ant-table-footer {
  border: 0;
  border-top: 1px solid #e9e9e9;
  border-right: 1px solid #e9e9e9;
}
.ant-table-bordered.ant-table-small .ant-table-footer:before {
  display: none;
}
.ant-table-bordered.ant-table-small .ant-table-placeholder {
  border-left: 0;
  border-bottom: 0;
}
.ant-table-placeholder {
  position: relative;
  padding: 16px 8px;
  background: #fff;
  border-bottom: 1px solid #e9e9e9;
  text-align: center;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.43);
}
.ant-table-placeholder .anticon {
  margin-right: 4px;
}
.ant-table-pagination {
  margin: 16px 0;
  float: right;
}
.ant-table-filter-dropdown {
  min-width: 96px;
  margin-left: -8px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}
.ant-table-filter-dropdown .ant-dropdown-menu {
  border: 0;
  box-shadow: none;
  border-radius: 4px 4px 0 0;
}
.ant-table-filter-dropdown .ant-dropdown-menu-without-submenu {
  max-height: 400px;
  overflow-x: hidden;
}
.ant-table-filter-dropdown .ant-dropdown-menu-item > label + span {
  padding: 0;
}
.ant-table-filter-dropdown .ant-dropdown-menu-sub {
  border-radius: 4px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}
.ant-table-filter-dropdown .ant-dropdown-menu .ant-dropdown-submenu-contain-selected .ant-dropdown-menu-submenu-title:after {
  color: #108ee9;
  font-weight: bold;
  text-shadow: 0 0 2px #d2eafb;
}
.ant-table-filter-dropdown .ant-dropdown-menu-item {
  overflow: hidden;
}
.ant-table-filter-dropdown > .ant-dropdown-menu > .ant-dropdown-menu-item:last-child,
.ant-table-filter-dropdown > .ant-dropdown-menu > .ant-dropdown-menu-submenu:last-child .ant-dropdown-menu-submenu-title {
  border-radius: 0;
}
.ant-table-filter-dropdown-btns {
  overflow: hidden;
  padding: 7px 8px;
  border-top: 1px solid #e9e9e9;
}
.ant-table-filter-dropdown-link {
  color: #108ee9;
}
.ant-table-filter-dropdown-link:hover {
  color: #49a9ee;
}
.ant-table-filter-dropdown-link:active {
  color: #0e77ca;
}
.ant-table-filter-dropdown-link.confirm {
  float: left;
}
.ant-table-filter-dropdown-link.clear {
  float: right;
}
.ant-table-selection-select-all-custom {
  margin-right: 4px !important;
}
.ant-table-selection .anticon-down {
  color: #aaa;
  transition: all .3s;
}
.ant-table-selection-menu {
  min-width: 96px;
  margin-top: 5px;
  margin-left: -30px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}
.ant-table-selection-menu .ant-action-down {
  color: #aaa;
}
.ant-table-selection-down {
  cursor: pointer;
  padding: 0;
  display: inline-block;
  line-height: 1;
}
.ant-table-selection-down:hover .anticon-down {
  color: #666;
}
.ant-table-row-expand-icon {
  cursor: pointer;
  display: inline-block;
  width: 17px;
  height: 17px;
  text-align: center;
  line-height: 14px;
  border: 1px solid #e9e9e9;
  user-select: none;
  background: #fff;
}
.ant-table-row-expanded:after {
  content: '-';
}
.ant-table-row-collapsed:after {
  content: '+';
}
.ant-table-row-spaced {
  visibility: hidden;
}
.ant-table-row-spaced:after {
  content: '.';
}
.ant-table-row[class*="ant-table-row-level-0"] .ant-table-selection-column > span {
  display: inline-block;
}
tr.ant-table-expanded-row,
tr.ant-table-expanded-row:hover {
  background: #fbfbfb;
}
.ant-table .ant-table-row-indent + .ant-table-row-expand-icon {
  margin-right: 8px;
}
.ant-table-scroll {
  overflow: auto;
  overflow-x: hidden;
}
.ant-table-scroll table {
  width: auto;
  min-width: 100%;
}
.ant-table-body-inner {
  height: 100%;
}
.ant-table-fixed-header > .ant-table-content > .ant-table-scroll > .ant-table-body {
  position: relative;
  background: #fff;
}
.ant-table-fixed-header .ant-table-body-inner {
  overflow: scroll;
}
.ant-table-fixed-header .ant-table-scroll .ant-table-header {
  overflow: scroll;
  padding-bottom: 20px;
  margin-bottom: -20px;
}
.ant-table-fixed-header.ant-table-empty .ant-table-scroll .ant-table-body {
  padding-bottom: 20px;
  margin-bottom: -20px;
}
.ant-table-fixed-left,
.ant-table-fixed-right {
  position: absolute;
  top: 0;
  overflow: hidden;
  transition: box-shadow 0.3s ease;
  border-radius: 0;
}
.ant-table-fixed-left table,
.ant-table-fixed-right table {
  width: auto;
  background: #fff;
}
.ant-table-fixed-header .ant-table-fixed-left .ant-table-body-outer .ant-table-fixed,
.ant-table-fixed-header .ant-table-fixed-right .ant-table-body-outer .ant-table-fixed {
  border-radius: 0;
}
.ant-table-fixed-left {
  left: 0;
  box-shadow: 6px 0 6px -4px rgba(0, 0, 0, 0.2);
}
.ant-table-fixed-left .ant-table-header {
  overflow-y: hidden;
}
.ant-table-fixed-left .ant-table-body-inner {
  margin-right: -20px;
  padding-right: 20px;
}
.ant-table-fixed-header .ant-table-fixed-left .ant-table-body-inner {
  padding-right: 0;
}
.ant-table-fixed-left,
.ant-table-fixed-left table {
  border-radius: 4px 0 0 0;
}
.ant-table-fixed-right {
  right: 0;
  box-shadow: -6px 0 6px -4px rgba(0, 0, 0, 0.2);
}
.ant-table-fixed-right,
.ant-table-fixed-right table {
  border-radius: 0 4px 0 0;
}
.ant-table-fixed-right .ant-table-expanded-row {
  color: transparent;
  pointer-events: none;
}
.ant-table.ant-table-scroll-position-left .ant-table-fixed-left {
  box-shadow: none;
}
.ant-table.ant-table-scroll-position-right .ant-table-fixed-right {
  box-shadow: none;
}
`,
    `.ant-table-wrapper {
  zoom: 1;
}
.ant-table-wrapper:before,
.ant-table-wrapper:after {
  content: " ";
  display: table;
}
.ant-table-wrapper:after {
  clear: both;
  visibility: hidden;
  font-size: 0;
  height: 0;
}
.ant-table {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
  overflow: hidden;
  position: relative;
  border-radius: 4px 4px 0 0;
  /* fix firefox scrollbar bug */
}
.ant-table-body {
  transition: opacity 0.3s ease;
}
.ant-table table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  text-align: left;
  border-radius: 4px 4px 0 0;
  overflow: hidden;
}
.ant-table-thead > tr > th {
  position: relative;
  background: #f7f7f7;
  font-weight: 500;
  transition: background .3s ease;
  text-align: left;
  color: rgba(0, 0, 0, 0.85);
}
.ant-table-thead > tr > th[colspan] {
  text-align: center;
}
.ant-table-thead > tr > th .anticon-filter,
.ant-table-thead > tr > th .ant-table-filter-icon {
  position: relative;
  margin-left: 4px;
  font-size: 12px;
  cursor: pointer;
  color: #aaa;
  transition: all .3s;
  width: 14px;
}
.ant-table-thead > tr > th .anticon-filter:hover,
.ant-table-thead > tr > th .ant-table-filter-icon:hover {
  color: rgba(0, 0, 0, 0.65);
}
.ant-table-thead > tr > th .anticon-filter:after,
.ant-table-thead > tr > th .ant-table-filter-icon:after {
  content: '';
  position: absolute;
  width: 14px;
  height: 50px;
  left: 0;
  top: -19px;
}
.ant-table-thead > tr > th .ant-table-filter-selected.anticon-filter {
  color: #108ee9;
}
.ant-table-thead > tr > th .drag-handle {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 3px;
  border-left: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
  transition: all .3s;
}
.ant-table-thead > tr > th .drag-handle:hover {
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
  cursor: ew-resize;
}
.ant-table-thead > tr > th:hover .drag-handle {
  visibility: visible;
  opacity: 1;
}
.ant-table-tbody > tr > td {
  border-bottom: 1px solid #e9e9e9;
  transition: all .3s;
}
.ant-table-thead > tr,
.ant-table-tbody > tr {
  transition: all .3s;
}
.ant-table-thead > tr.ant-table-row-hover > td,
.ant-table-tbody > tr.ant-table-row-hover > td,
.ant-table-thead > tr:hover > td,
.ant-table-tbody > tr:hover > td {
  background: #ecf6fd;
}
.ant-table-thead > tr:hover {
  background: none;
}
.ant-table-footer {
  padding: 16px 8px;
  background: #f7f7f7;
  border-radius: 0 0 4px 4px;
  position: relative;
}
.ant-table-footer:before {
  content: '';
  height: 1px;
  background: #f7f7f7;
  position: absolute;
  top: -1px;
  width: 100%;
  left: 0;
}
.ant-table.ant-table-bordered .ant-table-footer {
  border: 1px solid #e9e9e9;
}
.ant-table-title {
  padding: 16px 0;
  position: relative;
  top: 1px;
  border-radius: 4px 4px 0 0;
}
.ant-table.ant-table-bordered .ant-table-title {
  border: 1px solid #e9e9e9;
  padding-left: 8px;
  padding-right: 8px;
}
.ant-table-title + .ant-table-content {
  position: relative;
  border-radius: 4px 4px 0 0;
  overflow: hidden;
}
.ant-table-bordered .ant-table-title + .ant-table-content,
.ant-table-bordered .ant-table-title + .ant-table-content table {
  border-radius: 0;
}
.ant-table-without-column-header .ant-table-title + .ant-table-content,
.ant-table-without-column-header table {
  border-radius: 0;
}
.ant-table-tbody > tr.ant-table-row-selected {
  background: #fafafa;
}
.ant-table-thead > tr > th.ant-table-column-sort {
  background: #eee;
}
.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  padding: 16px 8px;
  word-break: break-all;
}
.ant-table-thead > tr > th.ant-table-selection-column-custom {
  padding-left: 16px;
  padding-right: 0;
}
.ant-table-thead > tr > th.ant-table-selection-column,
.ant-table-tbody > tr > td.ant-table-selection-column {
  text-align: center;
  min-width: 62px;
  width: 62px;
}
.ant-table-expand-icon-th,
.ant-table-row-expand-icon-cell {
  text-align: center;
  min-width: 50px;
  width: 50px;
}
.ant-table-header {
  background: #f7f7f7;
  overflow: hidden;
}
.ant-table-header table {
  border-radius: 4px 4px 0 0;
}
.ant-table-loading {
  position: relative;
}
.ant-table-loading .ant-table-body {
  background: #fff;
  opacity: 0.5;
}
.ant-table-loading .ant-table-spin-holder {
  height: 20px;
  line-height: 20px;
  left: 50%;
  top: 50%;
  margin-left: -30px;
  position: absolute;
}
.ant-table-loading .ant-table-with-pagination {
  margin-top: -20px;
}
.ant-table-loading .ant-table-without-pagination {
  margin-top: 10px;
}
.ant-table-middle .ant-table-thead > tr > th:not(.ant-table-selection-column),
.ant-table-middle .ant-table-tbody > tr > td {
  padding: 10px 8px;
}
.ant-table-middle .ant-table-title,
.ant-table-middle .ant-table-footer {
  padding: 10px 8px;
}
.ant-table-middle .ant-table-column-sorter-up:after {
  top: -13px;
  height: 13px;
}
.ant-table-middle .ant-table-column-sorter-down:after {
  bottom: -11px;
  height: 13px;
}
.ant-table-middle .ant-table-thead > tr > th .anticon-filter:after,
.ant-table-middle .ant-table-thead > tr > th .ant-table-filter-icon:after {
  height: 38px;
  top: -13px;
}
.ant-table-small {
  border: 1px solid #e9e9e9;
  border-radius: 4px;
}
.ant-table-small .ant-table-header > table,
.ant-table-small .ant-table-body > table {
  border: 0;
  padding: 0 8px;
}
.ant-table-small .ant-table-thead > tr > th {
  background: #fff;
  border-bottom: 1px solid #e9e9e9;
}
.ant-table-small .ant-table-tbody > tr > td {
  padding: 6px 8px;
}
.ant-table-small .ant-table-title,
.ant-table-small .ant-table-footer,
.ant-table-small .ant-table-thead > tr > th:not(.ant-table-selection-column) {
  padding: 10px 8px;
}
.ant-table-small .ant-table-title {
  border-bottom: 1px solid #e9e9e9;
  top: 0;
}
.ant-table-small .ant-table-header {
  background: #fff;
}
.ant-table-small .ant-table-header table {
  border-bottom: 1px solid #e9e9e9;
}
.ant-table-small .ant-table-placeholder,
.ant-table-small .ant-table-row:last-child td {
  border-bottom: 0;
}
.ant-table-small .ant-table-column-sorter-up:after {
  top: -14px;
  height: 13px;
}
.ant-table-small .ant-table-column-sorter-down:after {
  bottom: -11px;
  height: 13px;
}
.ant-table-small .ant-table-thead > tr > th .anticon-filter:after,
.ant-table-small .ant-table-thead > tr > th .ant-table-filter-icon:after {
  height: 39px;
  top: -14px;
}
.ant-table-column-sorter {
  position: relative;
  margin-left: 4px;
  display: inline-block;
  width: 14px;
  height: 14px;
  vertical-align: middle;
  text-align: center;
}
.ant-table-column-sorter-up,
.ant-table-column-sorter-down {
  line-height: 4px;
  display: block;
  width: 14px;
  cursor: pointer;
}
.ant-table-column-sorter-up:hover .anticon,
.ant-table-column-sorter-down:hover .anticon {
  color: rgba(0, 0, 0, 0.65);
}
.ant-table-column-sorter-up.on .anticon-caret-up,
.ant-table-column-sorter-down.on .anticon-caret-up,
.ant-table-column-sorter-up.on .anticon-caret-down,
.ant-table-column-sorter-down.on .anticon-caret-down {
  color: #108ee9;
}
.ant-table-column-sorter-up:after,
.ant-table-column-sorter-down:after {
  position: absolute;
  content: '';
  height: 20px;
  width: 14px;
  left: 0;
}
.ant-table-column-sorter-up:after {
  top: -19px;
}
.ant-table-column-sorter-down:after {
  bottom: -17px;
}
.ant-table-column-sorter .anticon-caret-up,
.ant-table-column-sorter .anticon-caret-down {
  display: inline-block;
  font-size: 12px;
  font-size: 8px \9;
  transform: scale(0.66666667) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
  line-height: 6px;
  height: 6px;
  color: #aaa;
}
:root .ant-table-column-sorter .anticon-caret-up,
:root .ant-table-column-sorter .anticon-caret-down {
  filter: none;
}
:root .ant-table-column-sorter .anticon-caret-up,
:root .ant-table-column-sorter .anticon-caret-down {
  font-size: 12px;
}
.ant-table-column-sorter .anticon-caret-up:before,
.ant-table-column-sorter .anticon-caret-down:before {
  -moz-transform-origin: 53% 50%;
  /* fix firefox position */
}
.ant-table-bordered .ant-table-header > table,
.ant-table-bordered .ant-table-body > table,
.ant-table-bordered .ant-table-fixed-left table,
.ant-table-bordered .ant-table-fixed-right table {
  border: 1px solid #e9e9e9;
  border-right: 0;
  border-bottom: 0;
}
.ant-table-bordered.ant-table-empty .ant-table-placeholder {
  border-left: 1px solid #e9e9e9;
  border-right: 1px solid #e9e9e9;
}
.ant-table-bordered.ant-table-fixed-header .ant-table-header > table {
  border-bottom: 0;
}
.ant-table-bordered.ant-table-fixed-header .ant-table-body > table {
  border-top: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.ant-table-bordered.ant-table-fixed-header .ant-table-body-inner > table {
  border-top: 0;
}
.ant-table-bordered.ant-table-fixed-header .ant-table-placeholder {
  border: 0;
}
.ant-table-bordered .ant-table-thead > tr > th {
  border-bottom: 1px solid #e9e9e9;
}
.ant-table-bordered .ant-table-thead > tr > th,
.ant-table-bordered .ant-table-tbody > tr > td {
  border-right: 1px solid #e9e9e9;
}
.ant-table-bordered.ant-table-small {
  border-right: 0;
}
.ant-table-bordered.ant-table-small .ant-table-header > table,
.ant-table-bordered.ant-table-small .ant-table-body > table,
.ant-table-bordered.ant-table-small .ant-table-fixed-left table,
.ant-table-bordered.ant-table-small .ant-table-fixed-right table {
  border: 0;
  padding: 0;
}
.ant-table-bordered.ant-table-small .ant-table-title {
  border: 0;
  border-bottom: 1px solid #e9e9e9;
  border-right: 1px solid #e9e9e9;
}
.ant-table-bordered.ant-table-small .ant-table-footer {
  border: 0;
  border-top: 1px solid #e9e9e9;
  border-right: 1px solid #e9e9e9;
}
.ant-table-bordered.ant-table-small .ant-table-footer:before {
  display: none;
}
.ant-table-bordered.ant-table-small .ant-table-placeholder {
  border-left: 0;
  border-bottom: 0;
}
.ant-table-placeholder {
  position: relative;
  padding: 16px 8px;
  background: #fff;
  border-bottom: 1px solid #e9e9e9;
  text-align: center;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.43);
}
.ant-table-placeholder .anticon {
  margin-right: 4px;
}
.ant-table-pagination {
  margin: 16px 0;
  float: right;
}
.ant-table-filter-dropdown {
  min-width: 96px;
  margin-left: -8px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}
.ant-table-filter-dropdown .ant-dropdown-menu {
  border: 0;
  box-shadow: none;
  border-radius: 4px 4px 0 0;
}
.ant-table-filter-dropdown .ant-dropdown-menu-without-submenu {
  max-height: 400px;
  overflow-x: hidden;
}
.ant-table-filter-dropdown .ant-dropdown-menu-item > label + span {
  padding: 0;
}
.ant-table-filter-dropdown .ant-dropdown-menu-sub {
  border-radius: 4px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}
.ant-table-filter-dropdown .ant-dropdown-menu .ant-dropdown-submenu-contain-selected .ant-dropdown-menu-submenu-title:after {
  color: #108ee9;
  font-weight: bold;
  text-shadow: 0 0 2px #d2eafb;
}
.ant-table-filter-dropdown .ant-dropdown-menu-item {
  overflow: hidden;
}
.ant-table-filter-dropdown > .ant-dropdown-menu > .ant-dropdown-menu-item:last-child,
.ant-table-filter-dropdown > .ant-dropdown-menu > .ant-dropdown-menu-submenu:last-child .ant-dropdown-menu-submenu-title {
  border-radius: 0;
}
.ant-table-filter-dropdown-btns {
  overflow: hidden;
  padding: 7px 8px;
  border-top: 1px solid #e9e9e9;
}
.ant-table-filter-dropdown-link {
  color: #108ee9;
}
.ant-table-filter-dropdown-link:hover {
  color: #49a9ee;
}
.ant-table-filter-dropdown-link:active {
  color: #0e77ca;
}
.ant-table-filter-dropdown-link.confirm {
  float: left;
}
.ant-table-filter-dropdown-link.clear {
  float: right;
}
.ant-table-selection-select-all-custom {
  margin-right: 4px !important;
}
.ant-table-selection .anticon-down {
  color: #aaa;
  transition: all .3s;
}
.ant-table-selection-menu {
  min-width: 96px;
  margin-top: 5px;
  margin-left: -30px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}
.ant-table-selection-menu .ant-action-down {
  color: #aaa;
}
.ant-table-selection-down {
  cursor: pointer;
  padding: 0;
  display: inline-block;
  line-height: 1;
}
.ant-table-selection-down:hover .anticon-down {
  color: #666;
}
.ant-table-row-expand-icon {
  cursor: pointer;
  display: inline-block;
  width: 17px;
  height: 17px;
  text-align: center;
  line-height: 14px;
  border: 1px solid #e9e9e9;
  user-select: none;
  background: #fff;
}
.ant-table-row-expanded:after {
  content: '-';
}
.ant-table-row-collapsed:after {
  content: '+';
}
.ant-table-row-spaced {
  visibility: hidden;
}
.ant-table-row-spaced:after {
  content: '.';
}
.ant-table-row[class*="ant-table-row-level-0"] .ant-table-selection-column > span {
  display: inline-block;
}
tr.ant-table-expanded-row,
tr.ant-table-expanded-row:hover {
  background: #fbfbfb;
}
.ant-table .ant-table-row-indent + .ant-table-row-expand-icon {
  margin-right: 8px;
}
.ant-table-scroll {
  overflow: auto;
  overflow-x: hidden;
}
.ant-table-scroll table {
  width: auto;
  min-width: 100%;
}
.ant-table-body-inner {
  height: 100%;
}
.ant-table-fixed-header > .ant-table-content > .ant-table-scroll > .ant-table-body {
  position: relative;
  background: #fff;
}
.ant-table-fixed-header .ant-table-body-inner {
  overflow: scroll;
}
.ant-table-fixed-header .ant-table-scroll .ant-table-header {
  overflow: scroll;
  padding-bottom: 20px;
  margin-bottom: -20px;
}
.ant-table-fixed-header.ant-table-empty .ant-table-scroll .ant-table-body {
  padding-bottom: 20px;
  margin-bottom: -20px;
}
.ant-table-fixed-left,
.ant-table-fixed-right {
  position: absolute;
  top: 0;
  overflow: hidden;
  transition: box-shadow 0.3s ease;
  border-radius: 0;
}
.ant-table-fixed-left table,
.ant-table-fixed-right table {
  width: auto;
  background: #fff;
}
.ant-table-fixed-header .ant-table-fixed-left .ant-table-body-outer .ant-table-fixed,
.ant-table-fixed-header .ant-table-fixed-right .ant-table-body-outer .ant-table-fixed {
  border-radius: 0;
}
.ant-table-fixed-left {
  left: 0;
  box-shadow: 6px 0 6px -4px rgba(0, 0, 0, 0.2);
}
.ant-table-fixed-left .ant-table-header {
  overflow-y: hidden;
}
.ant-table-fixed-left .ant-table-body-inner {
  margin-right: -20px;
  padding-right: 20px;
}
.ant-table-fixed-header .ant-table-fixed-left .ant-table-body-inner {
  padding-right: 0;
}
.ant-table-fixed-left,
.ant-table-fixed-left table {
  border-radius: 4px 0 0 0;
}
.ant-table-fixed-right {
  right: 0;
  box-shadow: -6px 0 6px -4px rgba(0, 0, 0, 0.2);
}
.ant-table-fixed-right,
.ant-table-fixed-right table {
  border-radius: 0 4px 0 0;
}
.ant-table-fixed-right .ant-table-expanded-row {
  color: transparent;
  pointer-events: none;
}
.ant-table.ant-table-scroll-position-left .ant-table-fixed-left {
  box-shadow: none;
}
.ant-table.ant-table-scroll-position-right .ant-table-fixed-right {
  box-shadow: none;
}
`
  ],
  providers: [TableService]
})
export class DataTableComponent implements OnInit, AfterViewInit {
  /** 渲染用data*/
  data: any[] = [];
  /** 未分页原始数据*/
  _dataSet: any[] = [];

  _el: HTMLElement;

  /** 分页设置*/
  _current = 1;
  _total: number;
  _pageSize = 10;
  _showLoading:boolean;


  _isInit = false;
  _isAjax = false;

  /**
   * 更改分页大小时触发
   */
  @Output() pageSizeChange: EventEmitter<any> = new EventEmitter();

  /**
   * 页码变化时触发事件
   */
  @Output() currentPageChange: EventEmitter<any> = new EventEmitter();

  /**
   * 表中数据更新时触发
   */
  @Output() dataChange: EventEmitter<any> = new EventEmitter();

  /**
   * 用户点击页码时触发
   */
  @Output() currentPageChangeClick: EventEmitter<any> = new EventEmitter();

  /**
   * 是否显示边框
   */
  @Input() showBordered = false;

  /**
   * 组件ui大小（small-middle-default）
   */
  @Input() nzSize: string;

  /**
   * 是否显示无数据时自定义的提示信息
   */
  @Input() customNoResult = false;

  /**
   * 是否显示分页
   * @memberof DataTableComponent
   */
  @Input() showPagination = true;

  /**
   * 是否显示“加载中”状态
   * @memberof DataTableComponent
   */
  @Input()
  set showLoading (value) {
    this._showLoading = value
  };
  get showLoading () {
    return this._showLoading
  };
  @Input() showSizeChanger = false;
  @Input() showQuickJumper = false;
  @Input() showTotal = false;
  @Input() showFooter = false;
  @Input() showTitle = false;

  /**
   * 是否固定表头只滚动内容
   * @memberof DataTableComponent
   */
  @Input() fixMode = false
  @Input() maxHeight = '600px' // 如果固定表头，设置最大高度
  /**
   * 是否使用hover十字线聚焦样式
   * @memberof DataTableComponent
   */
  @Input() crossMode = false

  /**
   * 异步数据
   * @memberof DataTableComponent
   */
  @Input()
  get asyncData() {
    return this.data;
  }

  set asyncData(data: any[]) {
    this._isAjax = true;
    this.data = data;
  }

  /** 同步静态数据 */
  @Input()
  get dataSource() {
    return this._dataSet;
  }

  set dataSource(value: any[]) {
    this._dataSet = value;
    this.total = this._dataSet.length;
    this._generateData(true);
  }

  @Input()
  get currentPage() {
    return this._current;
  };

  set currentPage(value: number) {
    if (this._current === value) {
      return;
    }
    this._current = value;
    this._generateData();
    this.currentPageChange.emit(this.currentPage);
  };


  @Input()
  get pageSize() {
    return this._pageSize;
  };

  set pageSize(value: number) {
    if (this._pageSize === value) {
      return;
    }
    this._pageSize = value;
    this._generateData();
    if (this._isInit) {
      this.pageSizeChange.emit(value);
    }
  };

  @Input()
  get total() {
    return this._total;
  };

  set total(value: number) {
    if (this._total === value) {
      return;
    }
    this._total = value;
  }

  constructor(private _elementRef: ElementRef,
              private render: Renderer2,
              private tableService: TableService) {
    this._el = this._elementRef.nativeElement;
  }
  ngOnInit() {
    if (this.crossMode) {
      const $table = this._el.querySelector('table')
      this.render.listen($table, 'mouseover', (event) => {
        const $target = event.target
        if ($target.tagName === 'TD' || $target.tagName === 'TH') {
          const index = Array.from($target.parentNode.children).indexOf($target)
          this.tableService.setupHover(index)
        }
      })
      this.render.listen($table, 'mouseleave', () => {
        this.tableService.setupHover(-1)
      })
      this.tableService.mouseover$.distinctUntilChanged()
      .subscribe(index => {
        const orgCols = Array.from(this._el.querySelectorAll('.hover-col'))
        orgCols.map(col => {
          col.classList.remove('hover-col')
        })
        if (index >= 0) {
          const trs = Array.from(this._el.querySelectorAll('tr'))
          trs.map(tr => {
            tr.children[index].classList.add('hover-col')
          })
        }
      })
    }
  }
  ngAfterViewInit() {
    this._isInit = true;
  }

  pageChangeClick(value) {
    this.currentPage = value;
    this.currentPageChangeClick.emit(value);
  }
  onScroll($event: any) {
    let top = event.srcElement.scrollTop
    this._el.querySelector('[bui-thead]').setAttribute('style', 'transform:translateY(' + top + 'px)')
  }

  _generateData(forceRefresh = false) {
    if (!this._isAjax) {
      if (this.showPagination) {
        if (forceRefresh) {
          this.currentPage = 1;
        }
        this.data = this._dataSet.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
      } else {
        this.data = this._dataSet;
      }
      this.dataChange.emit(this.data);
    }
  }
}

